import React, { useState } from 'react';
import { observer } from 'mobx-react';

import Toolbar from '@mui/material/Toolbar';

import SideList from './List';
import SwitherSideBar from './SwitherSideBar';
import stores from '@stores';

import * as S from './styles';

const LeftSideBar = () => {
  const [open, setOpen] = useState<boolean>(false);
  const {
    layoutStore: { isDrawerOpen, setDrawerOpen }
  } = stores;

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const toggleSidebar = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  return (
    <S.SideBar
      variant='permanent'
      open={open || isDrawerOpen}
      onMouseEnter={handleDrawerOpen}
      onMouseLeave={handleDrawerClose}
    >
      <Toolbar />
      <SideList isMenuOpen={open || isDrawerOpen}/>

      <SwitherSideBar defaultChecked={isDrawerOpen} toggleSidebar={toggleSidebar} />
    </S.SideBar>
  );
};

export default observer(LeftSideBar);
